import { createContext, useContext } from 'react';
import invariant from 'tiny-invariant';

import type { Page, PageViewed } from 'src/shared/telemetry';

type CurrentPage = Page | null;

type SegmentHistoryContext = {
  page: CurrentPage;
  metadata: PageViewed;
  setMetadata: (metadata: PageViewed) => void;
};

const defaultValue: SegmentHistoryContext = {
  page: null,
  metadata: {},
  setMetadata: () =>
    invariant(false, 'Setting metadata before provider is ready'),
};

const context = createContext(defaultValue);

const useTrackingMetadata = () => {
  const { metadata, setMetadata } = useContext(context);

  const mergeMetadata = (data: Partial<PageViewed>) => {
    setMetadata({ ...metadata, ...data });
  };

  return { metadata, mergeMetadata };
};

const { Provider } = context;

export {
  CurrentPage,
  Provider,
  SegmentHistoryContext,
  context,
  defaultValue,
  useTrackingMetadata,
};
